'use strict';

var React = require('react');
var styled = require('styled-components');
require('../../theme/breakpoints.js');
require('../../helpers/css-units.js');
require('../../theme/theme.js');
var spacing = require('../../theme/spacing.js');
var cell = require('./Cells/cell.js');
require('./Cells/cellActions.js');
require('./Cells/cellCheckbox.styles.js');
require('../Chip/component.js');
var cellIcon = require('./Cells/cellIcon.js');
require('../Tooltip/component.js');
require('../Pill/pill.styles.js');
require('../Pill/pillButton.styles.js');
require('../forms/Select/Control.js');
require('../forms/Select/Option.js');
require('../forms/Select/multi-select/OptionMulti.js');
require('../forms/Select/multi-select/ControlMulti.js');
require('./Cells/cellSubText.styles.js');
require('../forms/Switch/component.js');
require('../Tag/component.js');
var header = require('./Cells/header.js');
require('../Icon/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const EXPAND_CONTROL_ICON_WIDTH_PX = 16;
const EXPAND_CONTROL_COL_KEY = 'expanded';
function useExpandableRows(engine, withExpandableRows, getRowOptions) {
    const theme = styled.useTheme();
    const columnsWithExpandable = React.useMemo(() => {
        if (!withExpandableRows) {
            return [];
        }
        const expandControlColWidthPx = spacing.px(theme.designTokens.tableFirstColumCellPaddingLeft) +
            spacing.px(theme.designTokens.tableCellPadding) +
            EXPAND_CONTROL_ICON_WIDTH_PX;
        const getIsExpandable = (data) => {
            if (!getRowOptions)
                return true;
            const rowOptions = getRowOptions(data);
            if (rowOptions.expandable === undefined)
                return true;
            return rowOptions.expandable;
        };
        const makeExpandRow = (d) => (e) => {
            engine.toggleRowExpanded(d[engine.state.keyField]);
            e.preventDefault();
        };
        return [
            {
                key: EXPAND_CONTROL_COL_KEY,
                renderHeader: headerProps => React__default.default.createElement(header.Header, { ...headerProps, resizeEnabled: false }),
                renderCell: (data, cellProps) => (React__default.default.createElement(React__default.default.Fragment, null, getIsExpandable(data) ? (React__default.default.createElement(cellIcon.CellIcon, { name: engine.state.expandedRows.includes(data[engine.state.keyField]) ? 'down-filled' : 'next-filled', onClick: makeExpandRow(data), ...cellProps })) : (React__default.default.createElement(cell.Cell, { ...cellProps })))),
                width: expandControlColWidthPx,
            },
        ];
    }, [
        withExpandableRows,
        theme.designTokens.tableFirstColumCellPaddingLeft,
        theme.designTokens.tableCellPadding,
        getRowOptions,
        engine,
    ]);
    return { columnsWithExpandable };
}

exports.useExpandableRows = useExpandableRows;
//# sourceMappingURL=useExpandableRows.js.map
